"use client";

import { Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Reviews() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const reviews = [{
    name: "SARAH J.",
    date: "REVIEWED 12 NOV 2024",
    body: "Coastline installed our office AC system last month. The team was professional, tidy, and the system is whisper-quiet. Our staff are finally comfortable during the summer heat."
  }, {
    name: "DAVID M.",
    date: "REVIEWED 05 NOV 2024",
    body: "Had an emergency breakdown at home. Coastline arrived within two hours and fixed the issue immediately. Their expertise in climate control is unmatched in the Surrey area."
  }, {
    name: "EMMA R.",
    date: "REVIEWED 28 OCT 2024",
    body: "We use Coastline for our annual maintenance. They are always punctual and provide detailed reports. It gives us great peace of mind knowing our units are running efficiently."
  }, {
    name: "JAMES T.",
    date: "REVIEWED 15 OCT 2024",
    body: "Excellent service from start to finish. They helped us choose the right unit for our conservatory and the installation was seamless. Highly recommend their domestic services."
  }, {
    name: "LUCY B.",
    date: "REVIEWED 02 OCT 2024",
    body: "The energy efficiency of the new system they installed is incredible. Our electricity bills have dropped significantly. Professional, knowledgeable, and very friendly team."
  }, {
    name: "MARK W.",
    date: "REVIEWED 20 SEP 2024",
    body: "Coastline handled our commercial project with great care. They worked around our business hours to ensure no disruption. A truly reliable partner for climate control."
  }];
  return <section data-section-id="1568" id="reviewsandcontactcta" className="relative bg-background text-foreground py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute top-0 left-0 right-0 h-3" style={{
      backgroundImage: "repeating-linear-gradient(45deg, var(--primary) 0, var(--primary) 12px, var(--foreground) 12px, var(--foreground) 24px)"
    }} aria-hidden="true" />

      <div className="max-w-[1440px] mx-auto px-5 md:px-6 lg:px-10">
        {}
        <div ref={headerRef} className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-6 mb-16 md:mb-20">
          {}
          <div aria-hidden="true" className="pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 select-none font-default font-extrabold leading-none uppercase tracking-tighter text-foreground/[0.08]" style={{
          fontSize: "clamp(12rem, 22vw, 22rem)"
        }}>
            06
          </div>

          {}
          <div className={`relative lg:col-span-7 transition-all duration-[520ms] ease-[cubic-bezier(.2,.7,.2,1)] ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="flex items-center gap-2 mb-6">
              <span className="inline-block w-1.5 h-1.5 bg-primary" aria-hidden="true" />
              <span className="font-sans text-[0.6875rem] md:text-[0.8125rem] font-medium uppercase tracking-[0.18em] text-muted-foreground">
                COASTLINE — CLIENT FEEDBACK, PULLED FROM GOOGLE
              </span>
            </div>

            <h2 className="font-default font-extrabold uppercase leading-[0.95] tracking-tight text-foreground" style={{
            fontSize: "clamp(2.5rem, 5.6vw, 5rem)"
          }}>
              WHAT OUR{" "}
              <span className="relative inline-block">
                <span className="relative z-10">CLIENTS</span>
                <span className={`absolute left-0 bottom-1 h-1 bg-primary z-0 transition-all duration-[480ms] delay-[120ms] ease-[cubic-bezier(.2,.7,.2,1)] ${headerVisible ? "w-full" : "w-0"}`} aria-hidden="true" />
              </span>{" "}
              SAY (WE DIDN'T WRITE THIS)
            </h2>
          </div>

          {}
          <div className={`relative lg:col-span-5 flex flex-col items-start lg:items-end text-left lg:text-right transition-all duration-[520ms] delay-100 ease-[cubic-bezier(.2,.7,.2,1)] ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="font-default font-extrabold leading-none text-foreground tracking-tight" style={{
            fontSize: "clamp(4rem, 8vw, 7rem)"
          }}>
              4.9
            </div>

            <div className="flex items-center gap-1.5 mt-4">
              {[0, 1, 2, 3, 4].map(i => <Star key={i} data-index={i} className="w-6 h-6 md:w-7 md:h-7 text-primary" fill="currentColor" strokeWidth={1.75} />)}
            </div>

            <p className="font-sans text-[0.75rem] font-medium uppercase tracking-[0.08em] text-muted-foreground mt-4 max-w-xs lg:max-w-none">
              BASED ON 412 GOOGLE REVIEWS · UPDATED WEEKLY
            </p>

            <Link to="#" className="mt-5 inline-block group">
              <span className="font-sans text-[0.8125rem] font-bold uppercase tracking-[0.12em] text-foreground border-b-2 border-primary pb-1 group-hover:border-b-4 transition-all duration-200">
                VIEW ON GOOGLE →
              </span>
            </Link>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, i) => {
          return <ReviewCrate key={i} review={review} index={i} />;
        })}
        </div>
      </div>
    </section>;
}
function ReviewCrate({
  review,
  index
}: {
  review: {
    name: string;
    date: string;
    body: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div data-index={index} ref={ref} className={`group relative bg-background border border-border p-7 transition-all duration-300 ease-[cubic-bezier(.2,.7,.2,1)] hover:border-2 hover:border-primary hover:p-[27px] rounded-lg shadow-md ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
    transitionDelay: isVisible ? `${index * 70}ms` : "0ms"
  }}>
      {}
      <span aria-hidden="true" className="absolute top-3 left-3 w-1 h-1 bg-foreground group-hover:bg-primary transition-colors duration-300" />
      <span aria-hidden="true" className="absolute top-3 right-3 w-1 h-1 bg-foreground group-hover:bg-primary transition-colors duration-300" />
      <span aria-hidden="true" className="absolute bottom-3 left-3 w-1 h-1 bg-foreground group-hover:bg-primary transition-colors duration-300" />
      <span aria-hidden="true" className="absolute bottom-3 right-3 w-1 h-1 bg-foreground group-hover:bg-primary transition-colors duration-300" />

      {}
      <div className="flex items-center gap-1 mb-4">
        {[0, 1, 2, 3, 4].map(s => <Star key={s} data-index={s} className={`w-4 h-4 text-primary transition-opacity duration-200 ${isVisible ? "opacity-100" : "opacity-0"}`} fill="currentColor" strokeWidth={1.75} style={{
        transitionDelay: isVisible ? `${index * 70 + s * 90}ms` : "0ms"
      }} />)}
      </div>

      {}
      <p className="font-sans text-[0.75rem] font-medium uppercase tracking-[0.08em] text-muted-foreground mb-4">
        {review.date}
      </p>

      {}
      <p className="font-default text-[0.9375rem] leading-[1.6] text-foreground mb-6">
        {review.body}
      </p>

      {}
      <div className="flex items-end justify-between pt-4 border-t border-border">
        <h4 className="font-default text-[1.0625rem] font-bold tracking-[0.02em] uppercase text-foreground">
          {review.name}
        </h4>
        <span className="font-default font-bold text-foreground text-xl leading-none" aria-label="Google review">
          G
        </span>
      </div>
    </div>;
}